import Plyr from 'plyr/dist/plyr.polyfilled.js';

import '../../sass/blocks/video.scss';

(() => {
    const $videos = document.querySelectorAll('.video');

    if (!$videos) return;

    $videos.forEach($video => {
        let video = null;

        const $videoPlayerWrap = $video.querySelector('.video__player-wrap');
        const $videoPlayer = $video.querySelector('.video__player');
        const $playBtn = $video.querySelector('.video__play-btn');

        const initVideo = () => {
            if (!$videoPlayerWrap || !$videoPlayer) return;

            const { poster } = $videoPlayer.dataset;
            
            video = new Plyr($videoPlayer, {
                controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
            });

            if (poster) {
                video.on('ready', () => {
                    video.poster = poster;
                });
            }

            if ($playBtn) {
                $playBtn.addEventListener('click', () => {
                    video.play();
                });
            }
        };

        initVideo();
    });
})();
